export var NgEnterDirective = function () {
    'ngInject';
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                        var eAcInput = element[0].getElementsByTagName('input')[0];
                        if (eAcInput) {
                            eAcInput.blur(); // only for search box
                        }
                    });
                    event.preventDefault();
                }
            });
        }
    };
};
//# sourceMappingURL=ngEnter.directive.js.map